// src/content/news/newsContent.ts

import img1 from '../../assets/news/news1.png';
import img2 from '../../assets/news/news2.png';
import img3 from '../../assets/news/news3.png';

export interface NewsItem {
    id: number;
    headline: string;
    content: string;  // Plain text, no HTML
    date: string;
    comments: number;
    likes: number;
    shares: number;
    images: string[];
}

export const news_content = {
    header: {
        title: 'News',
    },

    articles: [
        {
            id: 1,
            headline: 'News Headline 1',
            content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.`,
            date: 'March 18, 2026',
            comments: 12,
            likes: 45,
            shares: 10,
            images: [img1],
        },
        {
            id: 2,
            headline: 'News Headline 2',
            content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.`,
            date: 'March 20, 2026',
            comments: 8,
            likes: 30,
            shares: 6,
            images: [img2],
        },
        {
            id: 3,
            headline: 'News Headline 3',
            content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.`,
            date: 'March 3, 2026',
            comments: 20,
            likes: 55,
            shares: 7,
            images: [img3],
        },
    ] as NewsItem[],
};